export default "__VITE_ASSET__D00SKM3c__"